import { Injectable } from '@angular/core';

import { enumFilerCodeState } from '@enum/enumFilerCodeState';
import { SelfFilerModel } from '@data-layer/models/companies';
import { CompaniesService } from './companies.service';
import { enumUserRole } from '@data-layer/enums/user';

@Injectable({
  providedIn: 'root',
})
export class SelfFilerService {
  private readonly isShowForUser: boolean = true;
  constructor(private companiesService: CompaniesService) {}

  public get isShowOnBoarding() {
    const userRoles = this.companiesService.getRoles();
    return this.isShowForUser ? true : userRoles.includes(enumUserRole.SUPPORT);
  }

  public isAllOnBoardingStateSuccess(info: SelfFilerModel): boolean {
    const filerCodeState = this.getOnBoardingObjectState(info.filerCodeDetails);
    const abiProfileState = this.getOnBoardingObjectState(info.abiProfileDetails);
    const achMethodState = this.getOnBoardingAchMethodState(info.achMethodDetails);
    return [filerCodeState, abiProfileState, achMethodState].every((state) => state === enumFilerCodeState.SUCCESS) && info.hasDatabase;
  }

  public getOnBoardingObjectState(details: { detailsSetTimestamp?: string; requestSentTimestamp?: string }): enumFilerCodeState {
    return details.detailsSetTimestamp
      ? enumFilerCodeState.SUCCESS
      : details.requestSentTimestamp
      ? enumFilerCodeState.SENT
      : enumFilerCodeState.ERROR;
  }

  public getOnBoardingAchMethodState(details: { paymentUnitNumber: string; requestSentTimestamp?: string }): enumFilerCodeState {
    return details.paymentUnitNumber && details.paymentUnitNumber.length === 6
      ? enumFilerCodeState.SUCCESS
      : details.requestSentTimestamp
      ? enumFilerCodeState.SENT
      : enumFilerCodeState.ERROR;
  }
}
